import { TApplicationStep } from '~/store/types';

export const TITLE_TEXT = 'Реєстрація компанії для переходу на нову систему Exim Business';

export const REMOTE_BANKING_CONTACTS_STEPS: TApplicationStep[] = [
  { title: <span style={{ whiteSpace: 'pre-line' }}>{'Автентифікація\nкерівника'}</span> },
  { title: 'Введення даних' },
  { title: 'Верифікація' },
  { title: 'Актуалізація даних' },
  { title: 'Підпис документа' },
];

export enum PersonRole {
  DIRECTOR = 'DIRECTOR',
  SOLE_TRADER = 'SOLE_TRADER',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
}

export enum SubmitApplicationStatus {
  NEW = 'NEW',
  VERIFIED = 'VERIFIED',
}
